import {MENUS} from "../menu";

export const ROUTER_NAMES = {
    DASHBOARDFORNECEDOR: 'Dashboard Fornecedor',
    DASHBOARDCOMPRADOR: 'Dashboard Comprador',
    EMPRESA: 'Painel',
}

export default [
    {
        name: ROUTER_NAMES.DASHBOARDFORNECEDOR,
        path: '/dashboard/fornecedor',
        meta: {
            menu: MENUS.FUNCIONALIDAES,
            searchAlias: 'Dashboard Fornecedor',
            searchDescription: 'Dashboard Fornecedor',
            searchTerms: ['Dashboard Fornecedor'],
            hasRole: 'role/dashboard/fornecedor'
        },
        component: () => import('@/views/Painel/Fornecedor')
    },
    {
        name: ROUTER_NAMES.DASHBOARDCOMPRADOR,
        path: '/dashboard/comprador',
        meta: {
            menu: MENUS.FUNCIONALIDAES,
            searchAlias: 'Dashboard Comprador',
            searchDescription: 'Dashboard Comprador',
            searchTerms: ['Dashboard Comprador'],
            hasRole: 'role/dashboard/comprador'
        },
        component: () => import('@/views/Painel/Comprador')
    },
    {
        name: ROUTER_NAMES.EMPRESA,
        path: '/painel',
        meta: {
            menu: MENUS.FUNCIONALIDAES,
            searchAlias: 'Painel',
            searchDescription: 'Painel',
            searchTerms: ['Painel'],
            hasRole: 'role/painel'
        },
        component: () => import('@/views/Painel/Empresa')
    },
]